export default {
  computed: {
    $typeAheadCallStatuses() {
      return [
        { uid: 1,
          value: "open",
          text: "Open",
          description: "The call is currently active or in progress."
        },
        { uid: 2,
          value: "closed",
          text: "Closed",
          description: "The call has been successfully completed or resolved."
        },
        { uid: 3,
          value: "pending",
          text: "Pending",
          description:"The call requires further action or follow-up."
        },
        { uid: 4,
          value: "on_hold",
          text: "On Hold",
          description:"The call is temporarily paused or awaiting information."
        },
        { uid: 5,
          value: "in_progress",
          text: "In Progress",
          description:"The call is actively being worked on by an agent."
        },
        { uid: 6,
          value: "completed",
          text: "Completed",
          description:"The call has been finished and all tasks related to it are done."
        },
        { uid: 7,
          value: "abandoned",
          text: "Abandoned",
          description:"The caller terminated the call before reaching an agent."
        },
        { uid: 8,
          value: "escalated",
          text: "Escalated",
          description:"The call has been forwarded to a higher level of support."
        },
        { uid: 9,
          value: "transferred",
          text: "Transferred",
          description:"The call was redirected to another department or agent."
        },
        { uid: 10,
          value: "voicemail",
          text: "Voicemail",
          description:"The call went to voicemail and was not answered live."
        },
        { uid: 11,
          value: "scheduled",
          text: "Scheduled",
          description:"A call has been scheduled for a future date or time."
        },
        { uid: 12,
          value: "callback_requested",
          text: "Callback Requested",
          description:"The caller has requested a callback from an agent."
        },
        { uid: 13,
          value: "no_answer",
          text: "No Answer",
          description:"The call was attempted but not answered by the recipient."
        },
        { uid: 14,
          value: "wrong_number",
          text: "Wrong Number",
          description:"The call was made to an incorrect or unavailable number."
        },
        { uid: 15,
          value: "duplicate",
          text: "Duplicate",
          description:"The same call or issue has been reported more than once."
        },
        { uid: 16,
          value: "follow_up_req",
          text: "Follow-Up Required",
          description:"Further action or investigation is needed."
        },
        { uid: 17,
          value: "waiting_for_info",
          text: "Waiting for Information",
          description:"The call is pending due to missing details."
        },
        { uid: 18,
          value: "unresolved",
          text: "Unresolved",
          description:"The call issue has not been resolved to satisfaction."
        },
        { uid: 19,
          value: "resolved",
          text: "Resolved",
          description:"The call issue has been successfully addressed."
        },
        { uid: 20,
          value: "hold_supervisor",
          text: "Hold for Supervisor",
          description:"A supervisor is reviewing or managing the call."
        },
        { uid: 21,
          value: "disconnected",
          text: "Disconnected",
          description:"The call was disconnected unintentionally."
        },
        { uid: 22,
          value: "no_show",
          text: "No Show",
          description:"An appointment or callback was not fulfilled by the recipient."
        },
        { uid: 23,
          value: "out_of_office",
          text: "Out of Office",
          description:"The call was made outside of regular business hours."
        },
        { uid: 24,
          value: "escalation_pending",
          text: "Escalation Pending",
          description:"A call is awaiting escalation to a higher authority."
        },
        { uid: 25,
          value: "follow_up_sched",
          text: "Follow-Up Scheduled",
          description:"A future follow-up call has been scheduled."
        },
      ];
    }
  }
};
